// Targets defined in /public/index.html

export default {
  root: document.getElementById('root')!,
  modal: document.getElementById('modalTarget')!,
  dropdown: document.getElementById('dropdownTarget')!,
  notification: document.getElementById('notificationsTarget')!,
  popper: document.getElementById('popperTarget')!,
  toastTarget: document.getElementById('toastTarget')!,
};
